import { useQuery } from "@tanstack/react-query";
import { getActivityLogs } from "services/activity-log.service";

export const useActivityLogs = (
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = ["activityLogs", params.page, params.size, params.search];

  return useQuery({
    queryKey,
    queryFn: () => getActivityLogs(params),
    ...options,
  });
};
